'use client'

import { useCartDrawer } from '@/app/[locale]/_components/CartDrawer/context'
import { useRouter } from '@/i18n/navigation'
import { useBreakpointValue } from '@chakra-ui/react'
import { useCallback } from 'react'

export function useProductCartRedirect(onClose?: () => void) {
  const router = useRouter()
  const { openCartDrawer } = useCartDrawer()
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )

  return useCallback(() => {
    onClose?.()
    if (isDesktop) {
      openCartDrawer()
    } else {
      router.push('/cart')
    }
  }, [onClose, isDesktop, openCartDrawer, router])
}
